module.exports = __webpack_public_path__ + "img/MARKS-alt.b8eb6804.svg";